import type { GateResult, GateSeverityCounts } from "@iamu/shared";

/** Stored gate summary as `build.list` / `gate.history` return it (dates arrive as strings). */
export interface GateSummaryView {
  id: string;
  buildId: string;
  status: GateResult["status"];
  evaluatedAt: string | Date;
  headline: string;
  counts: GateResult["counts"];
  coverage: GateResult["coverage"];
  verdicts: GateResult["verdicts"];
  baseline: { mode: string; label: string | null; environment: string };
}

export interface BuildSummary {
  id: string;
  label: string;
  gitSha: string | null;
  gitBranch: string | null;
  /** Runs were taken against uncommitted changes (label ends `+wip.<hash>`). */
  gitDirty: boolean;
  worktreeHash: string | null;
  environment: string;
  source: "cli" | "ci" | "implicit";
  status: "open" | "closed";
  firstRunAt: string | Date | null;
  lastRunAt: string | Date | null;
  closedAt: string | Date | null;
  runCount: number;
  gate: GateSummaryView | null;
}

export interface GateHistoryView extends GateSummaryView {
  label: string;
  gitBranch: string | null;
  environment: string;
  lastRunAt: string | Date | null;
}

export function severityTotal(c: GateSeverityCounts): number {
  return c.critical + c.major + c.minor;
}
